import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d0c0eb8&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d0c0eb8')) {
      api.createRecord('4d0c0eb8', component.options)
    } else {
      api.reload('4d0c0eb8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4d0c0eb8&", function () {
      api.rerender('4d0c0eb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/components/header-color/index.vue"
export default component.exports